import useSingleOrganization from '../../../hooks/useSingleOrganization'

/**
 * 
 * @returns Organization name
 */
export default function OrganizationName({organizationId, nbchar}: {organizationId?: string, nbchar?: number}) {
    const {singleOrganizationQuery:{isLoading, isError, data, }, organizationId: idfound} = useSingleOrganization(organizationId)

    if(idfound=== "") {
        return <>-</>
    }

    if (isLoading) {
        return <>...</>
    }

    if (isError) {
        return <>-</>
    }

    if (!data) {
        return <>-</>
    }

    const nameRaw= data.organization_name

    const name =  nbchar ? nameRaw?.substring(0, nbchar) +( nameRaw.length > nbchar ? "..." : "") : nameRaw
  return (
    <>{name}</>
  )
}
